import { Injectable } from '@angular/core'
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { LoadingController } from '@ionic/angular';
import { GlobalService } from './global.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    loading = null;
    endpoint = environment.APIEndpoint
    constructor(private httpClient: HttpClient,private loadingController: LoadingController) { }

    public updateEndpoint() {
        if (!window.location.hostname.includes("localhost")) {
            this.endpoint = environment.APIEndpointPROD;
        }
        return this.endpoint;
    }

    //Used to create information
    async post(url, in_data) {
        this.updateEndpoint();
        console.log("POST: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .post(this.endpoint + url, in_data, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }

    async postNoEndpoint(url, in_data) {
        this.updateEndpoint();
        console.log("POST: " + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .post(url, in_data, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }

    //Used to get information
    async get(url) {
        this.updateEndpoint();
        console.log("GET: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .get(this.endpoint + url, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";

                    resolve(error_data)
                })
        })
    }

    async getNoEndpoint(url) {
        return await new Promise((resolve, reject) => {
            this.httpClient
                .get(url, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";

                    resolve(error_data)
                })
        })
    }

    //Generally used to make an update
    async put(url, in_data) {
        this.updateEndpoint();
        console.log("PUT: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .put(this.endpoint + url, in_data, { withCredentials: true })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }

    //Used to delete a resource
    async delete(url, in_data) {
        this.updateEndpoint();
        console.log("DELETED: " + this.endpoint + url);
        return await new Promise((resolve, reject) => {
            this.httpClient
                .delete(this.endpoint + url, {
                    withCredentials: true,
                    body: in_data
                })
                .toPromise()
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    let error_data = {
                        status_code: err?.status,
                        success: false,
                        message: err?.error?.message,
                    }
                    if (!error_data.message) error_data.message = "Something went wrong";
                    resolve(error_data)
                })
        })
    }


    //Download a file
    async DownloadFile(file) {
        this.updateEndpoint();
        window.open(`${this.endpoint}files/download/${file.guid}`,'_blank');
    }
    async DownloadAsZip(guid_array) {
        this.updateEndpoint();
        let guid_string = guid_array.join("~");
        window.open(`${this.endpoint}files/download/zip/${guid_string}`,'_blank');
    }

    async GetDownloadURLPost(data,file) {
        this.updateEndpoint();
        let posted_data: any = await this.post(`download_code/${file.guid}`, data);
        let download_code = posted_data.download_code;
        return `${this.endpoint}files/download/${file.guid}?download_code=${download_code}`;
    }

    async DownloadFilePost(data,file) {
        let url = await this.GetDownloadURLPost(data,file);
        window.open(url,'_blank');
    }

    //This will upload a file using the block blob method for large files
     async UploadFile(file: File, folder_guid: string, extra_post_data?: any): Promise<string | null> {
        this.presentLoading(`Uploading ${file.name}`, 99999999999999);
        // extra_post_data lets callers pass e.g. { email_guid, document_request_guid } so this upload
        // fulfills a specific document request instead of just landing in folder_guid - see
        // files/get_upload_url in the backend, which resolves the real destination from email_guid
        // when present (overriding folder_guid) and links document_request_guid if also given.
        const post_data = { file_name: file.name, file_size: file.size, is_temp: false, ...(extra_post_data || {}) };

        // 1) Ask your API for a SAS upload URL (scoped to this blob) + guid
        const data: any = await this.post(`files/get_upload_url/${folder_guid}`, post_data);
        if (!data?.success) {
            this.dismissLoading();
            return null;
        }

        const sasUrl: string = data.data[0].upload_url;
        const fileGuid: string = data.data[0].file_guid;

        // Helper to add/override query params on the SAS URL
        const withParams = (url: string, params: Record<string, string>) => {
            const u = new URL(url);
            Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
            return u.toString();
        };

        // If file <= 32 MiB, a single PUT is fine; otherwise do block upload.
        const SINGLE_PUT_LIMIT = 32 * 1024 * 1024;

        if (file.size <= SINGLE_PUT_LIMIT) {
            // Single-shot PUT (simplest)
            await lastValueFrom(this.httpClient.put(sasUrl, file, {
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type || 'application/octet-stream'
                }
            }));
            this.put(`files/commit_upload/${fileGuid}`, null);
            this.dismissLoading();
            return fileGuid ?? null;
        }

        // 2) Chunked upload via Put Block + Put Block List
        const blockSize = 4 * 1024 * 1024; // 8 MiB blocks (tweak as you like)
        const blockIds: string[] = [];
        const totalBlocks = Math.ceil(file.size / blockSize);

        for (let i = 0; i < totalBlocks; i++) {
            const percent = Math.round(((i + 1) / totalBlocks) * 100);
            this.presentLoading(`Uploading ${file.name}: ${percent}%`, 99999999999999);
            console.log(`Uploading block ${i + 1} of ${totalBlocks}`);
            const start = i * blockSize;
            const end = Math.min(start + blockSize, file.size);
            const chunk = file.slice(start, end);

            // Block IDs must be base64 strings. Fixed-length numeric helps ordering.
            const rawId = `block-${i.toString().padStart(6, '0')}`;
            const blockId = btoa(rawId); // base64
            blockIds.push(blockId);

            const putBlockUrl = withParams(sasUrl, { comp: 'block', blockid: blockId });

            await lastValueFrom(this.httpClient.put(putBlockUrl, chunk, {
                headers: {
                    // No x-ms-blob-type for Put Block
                    'x-ms-version': '2020-10-02' // optional; any recent version your account supports
                }
            }));
        }

        // 3) Commit the block list (finalize the blob)
        const blockListXml =
            `<?xml version="1.0" encoding="utf-8"?>` +
            `<BlockList>${blockIds.map(id => `<Latest>${id}</Latest>`).join('')}</BlockList>`;

        const commitUrl = withParams(sasUrl, { comp: 'blocklist' });

        await lastValueFrom(this.httpClient.put(commitUrl, blockListXml, {
            headers: {
                'Content-Type': 'application/xml',
                'x-ms-blob-content-type': file.type || 'application/octet-stream'
            }
        }));



        this.put(`files/commit_upload/${fileGuid}`, null);
        this.dismissLoading();
        return fileGuid ?? null;
    }


    //This will upload a file using the block blob method for large files
     async UploadFileSecureEmail(guid,file: File, post_data): Promise<string | null> {
        this.presentLoading(`Uploading ${file.name}`, 99999999999999);

        // 1) Ask your API for a SAS upload URL (scoped to this blob) + guid
        const data: any = await this.post(`files/email/get_upload_url/${guid}`, post_data);
        if (!data?.success) {
            this.dismissLoading();
            return null;
        }

        const sasUrl: string = data.data[0].upload_url;
        const fileGuid: string = data.data[0].file_guid;

        // Helper to add/override query params on the SAS URL
        const withParams = (url: string, params: Record<string, string>) => {
            const u = new URL(url);
            Object.entries(params).forEach(([k, v]) => u.searchParams.set(k, v));
            return u.toString();
        };

        // If file <= 64 MiB, a single PUT is fine; otherwise do block upload.
        const SINGLE_PUT_LIMIT = 32 * 1024 * 1024;
        console.log("File Size: " + file.size);
        console.log("Single Put Limit: " + SINGLE_PUT_LIMIT);

        if (file.size <= SINGLE_PUT_LIMIT) {
            // Single-shot PUT (simplest)
            await lastValueFrom(this.httpClient.put(sasUrl, file, {
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type || 'application/octet-stream'
                }
            }));
            this.put(`files/commit_upload/${fileGuid}`, null);
            this.dismissLoading();
            return fileGuid ?? null;
        }

        // 2) Chunked upload via Put Block + Put Block List
        const blockSize = 4 * 1024 * 1024; // 8 MiB blocks (tweak as you like)
        const blockIds: string[] = [];
        const totalBlocks = Math.ceil(file.size / blockSize);

        for (let i = 0; i < totalBlocks; i++) {
            const percent = Math.round(((i + 1) / totalBlocks) * 100);
            this.presentLoading(`Uploading ${file.name}: ${percent}%`, 99999999999999);
            console.log(`Uploading block ${i + 1} of ${totalBlocks}`);
            const start = i * blockSize;
            const end = Math.min(start + blockSize, file.size);
            const chunk = file.slice(start, end);

            // Block IDs must be base64 strings. Fixed-length numeric helps ordering.
            const rawId = `block-${i.toString().padStart(6, '0')}`;
            const blockId = btoa(rawId); // base64
            blockIds.push(blockId);

            const putBlockUrl = withParams(sasUrl, { comp: 'block', blockid: blockId });

            await lastValueFrom(this.httpClient.put(putBlockUrl, chunk, {
                headers: {
                    // No x-ms-blob-type for Put Block
                    'x-ms-version': '2020-10-02' // optional; any recent version your account supports
                }
            }));
        }

        // 3) Commit the block list (finalize the blob)
        const blockListXml =
            `<?xml version="1.0" encoding="utf-8"?>` +
            `<BlockList>${blockIds.map(id => `<Latest>${id}</Latest>`).join('')}</BlockList>`;

        const commitUrl = withParams(sasUrl, { comp: 'blocklist' });

        await lastValueFrom(this.httpClient.put(commitUrl, blockListXml, {
            headers: {
                'Content-Type': 'application/xml',
                'x-ms-blob-content-type': file.type || 'application/octet-stream'
            }
        }));



        this.put(`files/commit_upload/${fileGuid}`, null);
        this.dismissLoading();
        return fileGuid ?? null;
    }

async presentLoading(message, duration) {
        if (this.loading == null) {

            this.loading = await this.loadingController.create({
                cssClass: 'my-custom-class',
                message: message,
                duration: duration
            });
            await this.loading.present();

            // const { role, data } = await this.loading.onDidDismiss()
        }
        else {
            this.loading.message = message;
        }
    }

  async dismissLoading() {
    console.log("Dismiss Loading");
    if (this.loading != null) {
      this.loading.dismiss();
      this.loading = null;
    }
  }




}
